import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import ScheduleIcon from '@mui/icons-material/Schedule';
import type { BuildStatus } from '@flowqa/shared';
import type { SvgIconComponent } from '@mui/icons-material';

export const getBuildStatusIconComponent = (status: BuildStatus): SvgIconComponent => {
  if (status === 'completed') return CheckCircleIcon;
  if (status === 'failed') return CancelIcon;
  if (status === 'running') return PlayCircleFilledIcon;
  return ScheduleIcon;
};
